export const VIDEO_VARIANT = 'highSchool'
export const TEACH_BUTTON_TEXT = 'Teach'
